import { action } from 'typesafe-actions';

import { RouteTypes } from './types';

// Drawer
export const setRouteActive = (payload: { routeActive: string }) =>
  action(RouteTypes.SET_ROUTE_ACTIVE, payload);
